import React from 'react';
import { motion } from 'framer-motion';

const WelcomeMessage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.5 }}
      className="bg-white rounded-xl shadow-lg p-8 max-w-3xl mx-auto mb-8"
    >
      <h3 className="text-xl font-semibold text-gray-800 mb-3 text-center">Welcome to Your New Beginning</h3>
      <p className="text-gray-600 leading-relaxed mb-4 text-center">
        You are not alone in this journey. Our community is here to support you with housing, employment, 
        counseling, legal aid, and spiritual guidance. Search above to find resources in your area.
      </p>
      <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-100">
        <p className="text-sm text-gray-700 italic text-center">
          "For I know the plans I have for you," declares the Lord, "plans to prosper you and not to harm you, 
          to give you hope and a future." - Jeremiah 29:11
        </p>
      </div>
    </motion.div>
  );
};

export default WelcomeMessage;